export const filterMixin = {

    data() {
        return {
            filterFlag: true,
        }
    },
    methods: {
        toggleFilter() {
            this.filterFlag = !this.filterFlag;
        },
    }
};



// WEBPACK FOOTER //
// ./src/util/filterMixin.js